import { theme } from "../../theme";

export const menuStyles = {
  "& .MuiPaper-root": {
    boxShadow: theme.boxShadow,
  },
};
